<div class="main-content" style="text-align: center">
  <div class="container-fluid center-block" style="max-width:500px; min-width:50%;display: flex; align-content: center;">
    <div class="card"  style="width: 60%; padding-top: 150px;" >
      <div class="card-header card-header-danger">
        <h3 class="card-title font-weight-bold">Unauthorized !!!</h3>
      </div>
      <div class="card-body">
        <p> You are unauthorized to access this resource!!!</p>
      <p> Please contact support</p>
      </div>
    </div>
  </div>
</div>
